const fontNameToDefinition = (fontName: string) => {
    if (fontName === 'IBM Plex Sans') {
        return `family=${fontName.replace(/ +/g, '+')}:wght@400;500;600`;
    }

    if (fontName === 'Rubik') {
        return `family=${fontName.replace(/ +/g, '+')}:wght@400;500`;
    }

    return `family=${fontName.replace(/ +/g, '+')}:wght@400;700`;
};

const compileGoogleFontsUrl = (fonts: Array<string>): string => {
    const fontDescription = fonts
        .filter((value, index, self) => self.indexOf(value) === index)
        .map(fontNameToDefinition)
        .join('&');

    return `https://fonts.googleapis.com/css2?${fontDescription}&display=swap&subset=latin,latin-ext,cyrillic`;
};

export default compileGoogleFontsUrl;
